<mat-sidenav-container class="mainWrapper" autosize autoFocus [ngClass]="{
  'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' && !options.horizontal && !resView,
  'sidebarNav-horizontal': options.horizontal,
  cardBorder: options.cardBorder,
  orange_theme: options.activeTheme == 'orange_theme',
  blue_theme: options.activeTheme == 'blue_theme',
  aqua_theme: options.activeTheme == 'aqua_theme',
  purple_theme: options.activeTheme == 'purple_theme'
}" [dir]="options.dir!">

  @if(!options.horizontal && !resView) {
  <mat-sidenav #leftsidenav position="start" [mode]="isOver ? 'over' : 'side'"
    [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="leftsidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="leftsidenav.toggle()"></app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <div class="p-16 m-t-auto profile-bar">
        <div class="bg-light-primary d-flex align-items-center rounded p-24">
          <div class="m-l-16">
            <h5 class="f-s-18 m-0 f-w-600 m-b-4">{{ userName }}</h5>
            <span class="f-s-14">{{ userRole }}</span>
          </div>
          <div class="m-l-auto">
            <button mat-icon-button (click)="logout()" class="d-flex justify-content-center">
              <i-tabler name="power" class="text-primary icon-18 d-flex"></i-tabler>
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>
  }

@if(options.horizontal && resView) {
  <mat-sidenav #mobilesidenav mode="over" position="start" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="toggleMobileSidebar()" [showToggle]="true"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="toggleMobileSidebar()"></app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <div class="p-16 m-t-auto profile-bar">
        <div class="bg-light-primary d-flex align-items-center rounded p-24">
          <div class="m-l-16">
            <h5 class="f-s-18 m-0 f-w-600 m-b-4">{{ userName }}</h5>
            <span class="f-s-14">{{ userRole }}</span>
          </div>
          <div class="m-l-auto">
            <button mat-icon-button (click)="logout()" class="d-flex justify-content-center">
              <i-tabler name="power" class="text-primary icon-18 d-flex"></i-tabler>
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>
  }

  <mat-sidenav-content class="contentWrapper" [ngClass]="{ 'p-l-24 p-r-24': !options.horizontal }" #content>
    
    @if(options.horizontal) {
      <app-horizontal-header (toggleMobileNav)="toggleMobileSidebar()"></app-horizontal-header>
      
      @if(!resView) {
        <app-horizontal-sidebar></app-horizontal-sidebar>
      }
    }

    @if(!options.horizontal) {
      <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="toggleMobileSidebar()"></app-header>
    }

    <main class="pageWrapper" [ngClass]="{ maxWidth: options.boxed }">
      <div class="m-t-10" [ngClass]="{ 'p-l-24 p-r-24': options.horizontal }">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
      </div>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>